import React from 'react';
import { Typography } from '@mui/material';
import StaffRegisterCard from '../uiParts/StaffRegisterCard';
import Header from '../uiParts/Header';
import MetaTitle from '../utils/MetaTitle';

const styles = {
  mypageWrapper: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    '@media screen and (min-width:960px)': {
      flexDirection: 'row',
    },
  },
  header: {
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1000,
  },
  contentArea: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    minHeight: 'calc(100vh - 64px)',
    marginTop: '64px',
    '@media screen and (max-width:960px)': {
      minHeight: 'calc(100vh - 48px)',
      marginTop: '48px',
    },
  },
  card: {
    width: '100%',
    maxWidth: '600px',
    padding: '40px 0 160px 0',
    '@media screen and (max-width:960px)': {
      padding: '24px 16px 80px 16px',
    },
    boxSizing: 'border-box',
  },
};

const StaffRegister = (): React.ReactElement => {
  return (
    <>
      <MetaTitle />
      <Typography component="div" sx={styles.mypageWrapper}>
        <Typography component="div" sx={styles.header}>
          <Header />
        </Typography>
        <Typography component="div" sx={styles.contentArea}>
          <Typography component="div" sx={styles.card}>
            <StaffRegisterCard />
          </Typography>
        </Typography>
      </Typography>
    </>
  );
};

export default StaffRegister;
